import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, createBlock as _createBlock, mergeProps as _mergeProps, renderSlot as _renderSlot, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5eec4c22"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "Pin relative z-1 flex-none flex justify-center items-center rounded-full text-black" };
const _hoisted_2 = { class: "Pin__Inner flex-none relative flex justify-center items-center" };
const _hoisted_3 = {
    key: 0,
    class: "Text Text--default absolute"
};
const _hoisted_4 = { class: "Text Text--selected absolute z-1" };
const _hoisted_5 = {
    key: 1,
    class: "Thumbnail absolute size-full bg-white"
};
const _hoisted_6 = { class: "p-px pt-2 bg-white" };
import { ref, watchPostEffect } from "vue";
import Viewport from "@/store/modules/Viewport";
import frames from "@/utils/frameToTime";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIMapHotspot',
    props: {
        thumbnail: {},
        as: { default: "button" },
        placement: { default: "top" },
        hideLabel: { type: Boolean },
        selected: { type: Boolean },
        delay: { default: 0 }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "7bf42612": (props.delay)
        }));
        const props = __props;
        const root = ref(null);
        watchPostEffect(() => {
            var _a;
            // release focus once selected
            props.selected && ((_a = root.value) === null || _a === void 0 ? void 0 : _a.blur());
        });
        return (_ctx, _cache) => {
            const _component_UICircularText = _resolveComponent("UICircularText");
            const _component_UIImage = _resolveComponent("UIImage");
            const _component_UIIcon = _resolveComponent("UIIcon");
            const _component_UIMaskReveal = _resolveComponent("UIMaskReveal");
            const _directive_cursor = _resolveDirective("cursor");
            const _directive_sound = _resolveDirective("sound");
            return (_openBlock(), _createBlock(_Transition, {
                duration: 1000 + _ctx.delay * 1000,
                appear: ""
            }, {
                default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.as), {
                        ref_key: "root",
                        ref: root,
                        class: _normalizeClass(["UIMapHotspot relative flex justify-center items-center pointer-events-none focus:outline-none", { hideLabel: _ctx.hideLabel, selected: _ctx.selected }]),
                        type: _ctx.$attrs.type || (_ctx.as === 'button' ? 'button' : undefined),
                        "data-placement": _ctx.placement
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    (!_unref(Viewport).isTouch)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            _createVNode(_component_UICircularText, {
                                                class: "size-full",
                                                text: _ctx.$t('map.hotspot.hover')
                                            }, null, 8, ["text"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createVNode(_component_UICircularText, {
                                            class: "size-full",
                                            text: _ctx.$t('map.hotspot.selected')
                                        }, null, 8, ["text"])
                                    ]),
                                    (!_unref(Viewport).isTouch)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                            (props.thumbnail)
                                                ? (_openBlock(), _createBlock(_component_UIImage, _normalizeProps(_mergeProps({ key: 0 }, props.thumbnail)), null, 16))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_UIIcon, {
                                        class: "Icon Icon--default absolute flex-none text-32",
                                        name: "symbol"
                                    }),
                                    _createVNode(_component_UIIcon, {
                                        class: "Icon Icon--selected absolute z-1 flex-none text-white",
                                        name: "check"
                                    })
                                ])
                            ]),
                            (_ctx.placement !== 'hidden')
                                ? (_openBlock(), _createBlock(_component_UIMaskReveal, {
                                    key: 0,
                                    class: "Label !absolute p-8 text-desktop-subtitle-1 whitespace-nowrap",
                                    delay: _ctx.delay + _unref(frames)(10)
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                            _renderSlot(_ctx.$slots, "default")
                                        ])
                                    ]),
                                    _: 3
                                }, 8, ["delay"]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 3
                    }, 8, ["class", "type", "data-placement"])), [
                        [
                            _directive_cursor,
                            void 0,
                            void 0,
                            { hover: true }
                        ],
                        [
                            _directive_sound,
                            void 0,
                            void 0,
                            {
                                hover: true,
                                click: true
                            }
                        ]
                    ])
                ]),
                _: 3
            }, 8, ["duration"]));
        };
    }
});
